// extracted by mini-css-extract-plugin
export var errorIcon = "_ki-1";
export var nameLogo = "_ki-0";